import { render, staticRenderFns } from "./StudyQuizQuestionMedicationPlan.vue?vue&type=template&id=838e34f0"
import script from "./StudyQuizQuestionMedicationPlan.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionMedicationPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports